import React, { Fragment, useState } from 'react';
import { Chip, Grid, Stack, Typography } from '@mui/material';
import { docGeniusPalette } from 'styles/partials/colors';
import { ContentElement } from '../../../ContentElement';
import styles from './ContentBlock.module.css';
import { generalIconList, contractIconList, quoteIconList } from './IconList';
import { useAppSelector } from 'app/hooks';
import { selectDocumentType, DocumentType } from 'features/document/documentSlice';
import { formatToTitleCase } from 'utils/formatDocumentType';

const ContentBlocks = () => {
  const documentType = useAppSelector(selectDocumentType);
  const formattedDocumentType = formatToTitleCase(documentType);
  const [iconList, setIconList] = useState(generalIconList);
  const isDefaultIconList = iconList === generalIconList;

  const handleOnClickGeneral = () => {
    setIconList(generalIconList);
  };

  const handleOnClickContract = () => {
    setIconList(contractIconList);
  };

  const handleOnClickQuote = () => {
    setIconList(quoteIconList);
  };

  return (
    <Fragment>
      <Typography variant='h4' color={docGeniusPalette.primaryBlue} align='left' fontSize='16px' fontWeight='500'>
        Content Blocks
      </Typography>
      {documentType !== DocumentType.DOCUMENT && documentType !== DocumentType.PRECLOSING && (
        <Stack direction='row' spacing={1} marginY={'16px'}>
          <Chip variant={isDefaultIconList ? 'filled' : 'outlined'} label='General' onClick={handleOnClickGeneral} />
          <Chip
            variant={!isDefaultIconList ? 'filled' : 'outlined'}
            label={formattedDocumentType}
            onClick={() => {
              documentType === DocumentType.CONTRACT ? handleOnClickContract() : handleOnClickQuote();
            }}
          />
        </Stack>
      )}
      <Grid container className={styles.contentSidebarGrid} wrap='wrap' direction='row'>
        {iconList.map(({ title, icon, type }) => (
          <Grid item key={`${type}-${title}`}>
            <ContentElement key={title} title={title} icon={icon} type={type} />
          </Grid>
        ))}
      </Grid>
    </Fragment>
  );
};

export default ContentBlocks;
